module.exports = "<div></div>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-principal/tela-principal.component.html
// module id = ../../../../../src/app/area-cliente/portal/tela-principal/tela-principal.component.html
// module chunks = 1